<div class="bk-page reports">
  <header class="bk-page__head">
    <div class="bk-page__intro">
      <p class="bk-eyebrow">SMS</p>
      <h1 class="bk-page__title">Delivery reports</h1>
      <p class="bk-page__sub">{{ description }}</p>
    </div>

    <div class="bk-page__actions">
      <report-period [value]="days" (valueChange)="setDays($event)" />
      <button type="button" class="bk-btn bk-btn--ghost" (click)="refresh()">
        <span class="bk-sym" aria-hidden="true">refresh</span>
        Refresh
      </button>
    </div>
  </header>

  <!-- The period in four figures, from delivery receipts -->
  <section class="bk-stats reports__stats" aria-label="Delivery in the period" [attr.aria-busy]="outcomeState === 'loading'">
    <div class="bk-stat">
      @if (outcomeState === "loading") {
        <span class="bk-skel stat-skel" aria-hidden="true"></span>
      } @else {
        <div class="bk-stat__value">{{ outcome ? formatCount(outcome.current.total) : "—" }}</div>
      }
      <div class="bk-stat__label">Recipients messaged</div>
      @if (outcome) {
        <div class="stat-note">
          @if (outcome.current.inFlight > 0) {
            {{ formatCount(outcome.current.inFlight) }} still on the way
          } @else if (outcome.current.total > 0) {
            Every receipt is in
          } @else {
            No sends in this period
          }
        </div>
      }
    </div>

    <div class="bk-stat">
      @if (outcomeState === "loading") {
        <span class="bk-skel stat-skel" aria-hidden="true"></span>
      } @else {
        <div class="bk-stat__value">{{ outcome ? formatCount(outcome.current.delivered) : "—" }}</div>
      }
      <div class="bk-stat__label">Delivered</div>
    </div>

    <div class="bk-stat" [attr.data-tone]="failedCount > 0 ? 'bad' : null">
      @if (outcomeState === "loading") {
        <span class="bk-skel stat-skel" aria-hidden="true"></span>
      } @else {
        <div class="bk-stat__value">{{ outcome ? formatCount(outcome.current.failed) : "—" }}</div>
      }
      <div class="bk-stat__label">Failed</div>
      @if (failedCount > 0 && tab !== "failures") {
        <button type="button" class="bk-more stat-link" (click)="showFailures()">
          See who failed <span class="bk-sym" aria-hidden="true">arrow_outward</span>
        </button>
      }
    </div>

    <div class="bk-stat">
      @if (outcomeState === "loading") {
        <span class="bk-skel stat-skel" aria-hidden="true"></span>
      } @else {
        <div class="bk-stat__value">{{ rate }}</div>
      }
      <div class="bk-stat__label">Delivery rate</div>
      @if (rateChange; as change) {
        <div class="stat-note stat-trend" [attr.data-tone]="change.tone">
          <span class="bk-sym" aria-hidden="true">{{
            change.tone === "ok" ? "trending_up" : change.tone === "bad" ? "trending_down" : "trending_flat"
          }}</span>
          {{ change.text }}
        </div>
      }
    </div>
  </section>

  @if (outcomeState === "error") {
    <p class="reports__alert" role="alert">The delivery counts could not be loaded. Check your connection, then select Refresh.</p>
  } @else {
    <p class="reports__fine">
      Counted from receipts stored with your organisation. A single message's report can show a few more.
    </p>
  }

  <app-routing-tab class="reports__tabs" [tabList]="tabs" />

  <div class="reports__body">
    @switch (tab) {
      @case ("failures") {
        <failures-report [days]="days" [reloadKey]="reloadKey" />
      }
      @case ("sent") {
        <sent-report [days]="days" [reloadKey]="reloadKey" />
      }
      @default {
        <section class="dash" aria-labelledby="reports-dash-title">
          <div class="dash__head">
            <div class="dash__intro">
              <h2 class="bk-section-title" id="reports-dash-title">Dashboard</h2>
              <p class="dash__note">Charts from Metabase. Use the dashboard's own filters for dates; the period above does not change them.</p>
            </div>
            <div class="dash__actions">
              <button
                type="button"
                class="bk-icon-btn"
                aria-label="Reload dashboard"
                matTooltip="Reload dashboard"
                (click)="reloadDashboard()"
              >
                <span class="bk-sym" aria-hidden="true">refresh</span>
              </button>
              @if (canFullscreen) {
                <button
                  type="button"
                  class="bk-icon-btn"
                  aria-label="Show dashboard full screen"
                  matTooltip="Full screen"
                  (click)="openFullscreen()"
                >
                  <span class="bk-sym" aria-hidden="true">open_in_full</span>
                </button>
              }
            </div>
          </div>

          <div class="bk-panel dash__frame">
            <metabase-embed [dashboardId]="dashboardId" [orgIdOverride]="orgId" frameTitle="Delivery dashboard" />
          </div>
        </section>
      }
    }
  </div>
</div>
